<template>
  <div class="groupon-settings page-pad">
    <el-card shadow="never">
      <div slot="header" class="hdr">
        <span>团购平台对接</span>
        <el-button type="primary" size="small" :loading="saving" @click="save">保存全部配置</el-button>
      </div>
      <el-alert
        type="info"
        :closable="false"
        show-icon
        title="三平台配置结构一致：可分别启用与关闭 Mock。关闭 Mock 后请填写 Access Token / Developer ID（真接口签名仍按平台文档补齐）。"
        style="margin-bottom: 16px"
      />
      <el-form label-width="140px" size="small">
        <el-divider content-position="left">美团</el-divider>
        <el-form-item label="启用">
          <el-switch v-model="form.meituan.enabled" />
        </el-form-item>
        <el-form-item label="Mock 模式">
          <el-switch v-model="form.meituan.mock" />
          <span class="hint">关闭后需填写 access_token</span>
        </el-form-item>
        <el-form-item label="Access Token">
          <el-input v-model="form.meituan.access_token" placeholder="经营宝授权后的 appAuthToken" />
        </el-form-item>
        <el-form-item label="Developer ID">
          <el-input v-model="form.meituan.developer_id" placeholder="美团开发者 ID" />
        </el-form-item>

        <el-divider content-position="left">抖音</el-divider>
        <el-form-item label="启用">
          <el-switch v-model="form.douyin.enabled" />
        </el-form-item>
        <el-form-item label="Mock 模式">
          <el-switch v-model="form.douyin.mock" />
          <span class="hint">关闭后需填写 access_token（来客开放平台）</span>
        </el-form-item>
        <el-form-item label="Access Token">
          <el-input v-model="form.douyin.access_token" placeholder="抖音来客 client_token / access_token" />
        </el-form-item>
        <el-form-item label="Developer ID">
          <el-input v-model="form.douyin.developer_id" placeholder="抖音应用 / 账户 ID" />
        </el-form-item>
        <el-form-item label="Account ID">
          <el-input v-model="form.douyin.account_id" placeholder="可选：商家 account_id" />
        </el-form-item>

        <el-divider content-position="left">饿了么</el-divider>
        <el-form-item label="启用">
          <el-switch v-model="form.eleme.enabled" />
        </el-form-item>
        <el-form-item label="Mock 模式">
          <el-switch v-model="form.eleme.mock" />
          <span class="hint">关闭后需填写 access_token（本地生活/口碑）</span>
        </el-form-item>
        <el-form-item label="Access Token">
          <el-input v-model="form.eleme.access_token" placeholder="本地生活授权 token" />
        </el-form-item>
        <el-form-item label="Developer ID">
          <el-input v-model="form.eleme.developer_id" placeholder="应用 / 开发者 ID" />
        </el-form-item>
        <el-form-item label="App Key">
          <el-input v-model="form.eleme.app_key" placeholder="可选：App Key" />
        </el-form-item>
      </el-form>

      <el-divider content-position="left">接口速查</el-divider>
      <ul class="api-list">
        <li>GET /api/groupon/status</li>
        <li>POST /api/groupon/sync-by-mobile（小程序）</li>
        <li>POST /api/groupon/add-code（小程序添加券码）</li>
        <li>GET /api/groupon/wallet</li>
        <li>POST /api/groupon/cashier/prepare · consume · query-mobile</li>
      </ul>
    </el-card>
  </div>
</template>

<script>
import { formatApiError } from '../utils/apiError'

function emptyPlat() {
  return {
    enabled: true,
    mock: true,
    access_token: '',
    developer_id: '',
    account_id: '',
    app_key: ''
  }
}

export default {
  name: 'GrouponSettings',
  data() {
    return {
      saving: false,
      form: {
        meituan: emptyPlat(),
        douyin: emptyPlat(),
        eleme: emptyPlat()
      }
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    applyPlatform(p, row) {
      if (!p || !this.form[p]) return
      const target = this.form[p]
      target.enabled = row.enabled !== false && Number(row.enabled) !== 0
      target.mock = row.mock !== false && Number(row.mock_mode) !== 0
      if (row.access_token != null) target.access_token = String(row.access_token || '')
      if (row.developer_id != null) target.developer_id = String(row.developer_id || '')
      if (row.account_id != null) target.account_id = String(row.account_id || '')
      if (row.app_key != null) target.app_key = String(row.app_key || '')
      let extra = row.extra_json
      if (typeof extra === 'string') {
        try {
          extra = JSON.parse(extra)
        } catch (_e) {
          extra = {}
        }
      }
      if (extra && typeof extra === 'object') {
        if (extra.developer_id != null && !target.developer_id) {
          target.developer_id = String(extra.developer_id)
        }
        if (extra.account_id != null && !target.account_id) {
          target.account_id = String(extra.account_id)
        }
      }
    },
    async load() {
      try {
        const resp = await this.$api.get('/groupon/admin/config')
        if (resp && resp.code === 200 && resp.data) {
          ;['meituan', 'douyin', 'eleme'].forEach((p) => {
            if (resp.data[p]) this.applyPlatform(p, resp.data[p])
          })
          return
        }
      } catch (_e) {
        /* fallback status */
      }
      try {
        const resp = await this.$api.get('/groupon/status')
        if (resp && resp.code === 200 && resp.data && Array.isArray(resp.data.platforms)) {
          resp.data.platforms.forEach((p) => this.applyPlatform(p.platform, p))
        }
      } catch (_e2) {
        /* ignore */
      }
    },
    async saveOne(platform, cfg) {
      await this.$api.post('/groupon/admin/auth', {
        platform,
        store_id: 0,
        access_token: cfg.access_token || '',
        app_key: cfg.app_key || '',
        mock_mode: cfg.mock ? 1 : 0,
        enabled: cfg.enabled ? 1 : 0,
        extra_json: {
          developer_id: cfg.developer_id || '',
          account_id: cfg.account_id || ''
        }
      })
    },
    async save() {
      this.saving = true
      try {
        await this.saveOne('meituan', this.form.meituan)
        await this.saveOne('douyin', this.form.douyin)
        await this.saveOne('eleme', this.form.eleme)
        this.$message.success('三平台配置已保存')
        this.load()
      } catch (e) {
        this.$message.error(formatApiError(e, '保存失败'))
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hint {
  margin-left: 10px;
  color: #64748b;
  font-size: 12px;
}
.api-list {
  margin: 0;
  padding-left: 18px;
  color: #334155;
  line-height: 1.8;
  font-size: 13px;
}
.page-pad {
  padding: 16px;
}
</style>
